export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_howie-mbk/artifacts/za39nkp4_FFA5FF9A-6700-4F37-BFF7-A65FBDCDA406_1_201_a%20%281%29.webp",
  brotherhood: "https://customer-assets.emergentagent.com/job_howie-mbk/artifacts/9nveq0g8_DSC06139.webp",
  founder: "https://customer-assets.emergentagent.com/job_howie-mbk/artifacts/4bjpo7qw_DSC06143.webp",
  graduation: "https://images.unsplash.com/photo-1657781763968-253a9656bfba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  study: "https://images.unsplash.com/photo-1634951401794-6c84f593db82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  portrait: "https://images.unsplash.com/photo-1596478454926-473e1a88a639?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  gradProfile: "https://images.unsplash.com/photo-1730990224970-a0b6d6276d51?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const siteConfig = {
  orgName: "My Brother's Keepers Club",
  founder: "Ollie Howie",
  primaryCta: "Apply as a Scholar",
  secondaryCta: "Learn About the Club",
  applyUrl: "#apply",
  contact: {
    email: "olliehowie1@gmail.com",
    address: "PO Box 6085, Roanoke, VA 24017",
  },
  nav: [
    { label: "Mission", href: "#mission" },
    { label: "Why It Matters", href: "#why" },
    { label: "Pillars", href: "#pillars" },
    { label: "Pathway", href: "#pathway" },
    { label: "Founder", href: "#founder" },
    { label: "Contact", href: "#contact" },
  ],
  hero: {
    eyebrow: "A Youth Development Initiative",
    headlineLines: [
      "Building pathways",
      "to opportunity",
      "for the next",
      "generation of scholars.",
    ],
    subhead:
      "My Brother's Keepers Club prepares young men for leadership, scholarship, and long-term success through mentorship, community, and opportunity.",
    founderLine: "Founded by Ollie Howie",
  },
  marquee: [
    "Mentorship",
    "Leadership",
    "Scholarship",
    "Brotherhood",
    "Opportunity",
    "Civic Purpose",
  ],
  mission: {
    eyebrow: "Our Mission",
    statement:
      "We exist to build safe, supportive communities where young men are valued, mentored, and given a clear pathway to opportunity.",
    chapters: [
      {
        n: "01",
        title: "Purpose",
        body: "My Brother's Keepers Club was founded on a single conviction: talent is universal, but opportunity is not. We close that gap by surrounding young men with mentorship, structure, and belief.",
      },
      {
        n: "02",
        title: "Approach",
        body: "We combine one-on-one mentorship, leadership training, and scholarship access into a sustained program, not a one-time event. Every scholar is known, supported, and expected to lead.",
      },
      {
        n: "03",
        title: "Commitment",
        body: "We measure success in outcomes: graduation, admission, careers, and character. Our work is long-term, community-rooted, and accountable to the families and schools who trust us.",
      },
    ],
  },
  why: {
    eyebrow: "Why It Matters",
    heading:
      "When young men are seen, mentored, and challenged, their outcomes change.",
    body: "Too many capable young men navigate school and adulthood without a consistent mentor, a clear plan, or a community that expects the best of them. That absence is not a lack of potential, it is a lack of pathways. My Brother's Keepers Club builds those pathways deliberately.",
    stats: [
      { value: "1:1", label: "Mentor-to-scholar relationships at the core of the program" },
      { value: "6", label: "Focus pillars guiding every scholar's development" },
      { value: "K–12+", label: "Support spanning school, college readiness, and career" },
    ],
    quote:
      "Every young man deserves to be told, by someone who means it, that his future is worth building.",
  },
  pillars: {
    eyebrow: "Our Pillars",
    heading: "Six focus areas that shape every scholar.",
    items: [
      { n: "01", title: "Mentorship", body: "Consistent guidance from mentors invested in each scholar's growth, character, and goals." },
      { n: "02", title: "Leadership", body: "Practical leadership development that builds confidence, responsibility, and voice." },
      { n: "03", title: "Scholarship Access", body: "Academic support and clear pathways to scholarships, college, and beyond." },
      { n: "04", title: "Career Exposure", body: "Exposure to professions, networks, and real-world opportunity early and often." },
      { n: "05", title: "Brotherhood", body: "A community of accountability and belonging where scholars support one another." },
      { n: "06", title: "Civic Development", body: "Grounding in service, citizenship, and the responsibility to give back." },
    ],
  },
  pathway: {
    eyebrow: "The Scholar Pathway",
    heading: "What it means to be a scholar.",
    forWhom:
      "The Club is for motivated young men ready to invest in their growth, their community, and their future, regardless of where they are starting.",
    receive: [
      "A dedicated mentor and a supportive brotherhood",
      "Leadership training and academic guidance",
      "Access to scholarship and career opportunities",
      "A structured path from where you are to where you're going",
    ],
    expect: [
      "Consistent participation and effort",
      "Respect for the community and its mission",
      "Willingness to lead, serve, and grow",
    ],
  },
  founderData: {
    eyebrow: "Founder",
    name: "Ollie Howie",
    title: "Founder, My Brother's Keepers Club",
    bio: [
      "Ollie Howie founded My Brother's Keepers Club to build the kind of opportunity he believes every young man deserves: mentorship, structure, and a community that expects greatness.",
      "A Harvard graduate and leader in investment and community development, he has been recognized by President Barack Obama for his commitment to opportunity and civic impact.",
      "His vision is simple and durable, to create a visible, credible institution that turns potential into pathways, and pathways into lasting outcomes for the scholars it serves.",
    ],
    facts: [
      { label: "Education", value: "Harvard University" },
      { label: "Recognition", value: "Honored by President Barack Obama" },
      { label: "Focus", value: "Investment & Community Development" },
    ],
  },
  apply: {
    eyebrow: "Application",
    heading: "Apply as a Scholar.",
    intro:
      "Applications are reviewed on a rolling basis. Complete each step below, review your responses, and submit. You'll receive a confirmation reference once your application is received.",
    who: "Motivated young men seeking mentorship, leadership, and opportunity.",
    commitment: "Sustained participation in mentorship and program activities.",
    deadline: "Rolling admissions — apply anytime.",
  },
};
